import {
  IPerformanceSheetConfig,
  IPerformanceSheetConfigCriteria,
  IPerformanceSheetConfigFilter,
} from '../../performance-sheets/config';

import { ITargetConfigResponse } from './target-config.response';

export type ITargetConfigCriteria = IPerformanceSheetConfigCriteria;
export type ITargetConfigFilter = IPerformanceSheetConfigFilter;

export interface ITargetConfig
  extends Omit<IPerformanceSheetConfig, 'criteria'> {
  criteria: ITargetConfigCriteria[];
}

export enum PRINT_VIEW_TEMPLATES {
  TARGET_SHEET = 'targetSheet',
  ACHIEVEMENT_SHEET = 'achievementSheet',
}

export enum TARGET_CONFIG_TYPES {
  SCHEDULE = 'SCHEDULE',
  TARGETS = 'TARGETS',
  MONTH_END_PROCESS = 'MONTH_END_PROCESS',
}

export interface TargetSheetConfigResponse {
  data: ITargetConfigResponse[];
  message: string;
  success: boolean;
}
